<!-- <div class="col-md-1 checkbox-align">
  <app-checkbox
    [value]="checked"
    (change)="checkboxUpdate($event)"
  ></app-checkbox>
</div> -->
<div class="col-md-12">
  <div class="row-container">
    <div class="col-container">
      <eps-checkbox [(ngModel)]="checked" (ngModelChange)="checkboxUpdate()"></eps-checkbox>
    </div>
    <div class="col-container" *ngFor="let col of columns">
      <div *ngIf="col.id !== 'includedInCount'">
        {{ renderColumn(col.id) }}
      </div>
    </div>
  </div>
  <div class="row-container">
    <div class="col-container"></div>
    <app-stock-count-order-items class="sub-material" [materials]="order.item" [definitions]="definitions"></app-stock-count-order-items>
  </div>
</div>
